<template>
<div class="chapter">
<div class="inner_page">
      ﻿

<title>
Cover</title><link href="9780312322496_epub_css_r1.css" rel="stylesheet" type="text/css"/>
<meta content="text/html; charset=utf-8" http-equiv="content-type"/>
<div style="height:100%;margin-top:0;text-align:center;">
<img alt="Cover Image" src="OEBPS/images/Wilc_9780312322496_epub_cvi_r1.png" style="height:100%"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780312322496_epub_cvi_r1.vue?783724e2